import type { W_Item_FindRelatedOrdersTable_VM_Row } from 'ab-api/web/item/findRelatedOrdersTable';

import { CUSTOMER_SERVICE_NAME } from '@acceligentllc/shared/constants/value';

const CSV_HEADER_KEYS = [
	'ID',
	'Status',
	'Operator',
	'Delivery Method',
	'Type',
	'Date Submitted',
	'Date Needed',
	'Location',
	'Quantity',
	'Requested At',
	'Requested By',
];

export const toCSVData = (viewModels: W_Item_FindRelatedOrdersTable_VM_Row[]) => {
	const header: string[] = [...CSV_HEADER_KEYS];

	const rows = viewModels.reduce((_acc, _order) => {
		_acc.push([
			`${_order.id}`,
			_order.status,
			_order.operator,
			_order.deliveryMethod,
			_order.orderType,
			_order.dateSubmitted ? `${_order.dateSubmitted}` : '',
			_order.dateNeeded,
			_order.location,
			`${_order.unfulfilledQuantity
			+ _order.unassignedQuantity
			+ _order.awaitingDeliveryQuantity
			+ _order.awaitingPickupQuantity
			+ _order.fulfilledQuantity
			+ _order.onOrderQuantity
			+ _order.partialOrderQuantity
			+ _order.returnedQuantity
			}`,
			_order.requestedAt,
			_order.requestedBy ? `${_order.requestedBy}` : CUSTOMER_SERVICE_NAME,
		]);
		return _acc;
	}, [] as string[][]);

	return [header, ...rows];
};
